/**
 * Okta (Samsara) OAuth Configuration
 */
export const oktaConfig = {
  clientId: process.env.NEXT_PUBLIC_OKTA_CLIENT_ID || '0oa1r8j7ltqD9pAwt358',

  redirectUri:
    process.env.NEXT_PUBLIC_OKTA_REDIRECT_URI ||
    (typeof window !== 'undefined'
      ? `${window.location.origin}/oauth`
      : 'https://app.enumerate.ai/oauth'),

  endpoints: {
    authorization: 'https://samsara.okta.com/oauth2/v1/authorize',
    token: 'https://samsara.okta.com/oauth2/v1/token',
    userinfo: 'https://samsara.okta.com/oauth2/v1/userinfo',
  },

  scopes: ['openid', 'email', 'profile'],
  responseType: 'code',
};

// Prefix to identify Samsara OAuth in state parameter
export const SAMSARA_STATE_PREFIX = 'samsara_';

const generateRandomString = (length: number): string => {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const randomValues = new Uint8Array(length);
  if (typeof window !== 'undefined') {
    window.crypto.getRandomValues(randomValues);
  }
  for (let i = 0; i < length; i++) {
    result += charset[randomValues[i] % charset.length];
  }
  return result;
};

export const getOktaAuthorizationUrl = (): string => {
  const state = SAMSARA_STATE_PREFIX + generateRandomString(32);
  const nonce = generateRandomString(32);

  const params = new URLSearchParams({
    client_id: oktaConfig.clientId,
    redirect_uri: oktaConfig.redirectUri,
    response_type: oktaConfig.responseType,
    scope: oktaConfig.scopes.join(' '),
    state,
    nonce,
  });

  return `${oktaConfig.endpoints.authorization}?${params.toString()}`;
};

export const oktaOAuthConfig = {
  redirectDelays: { success: 2000, error: 2000 },
  errorParams: { oauthFailed: 'oauth_failed', authCheckFailed: 'auth_check_failed' },
  routes: { signIn: '/sign_in', home: '/home/' },
  messages: {
    serverAuthFailed: 'Failed to authenticate with server',
    authVerificationFailed: 'Authentication verification failed',
    verificationFailed: 'Failed to verify authentication',
  },
} as const;
